import {
	SEARCH_PARTS_SUCCESS,
	REQUEST_PARTS_PENDING,
	REQUEST_PARTS_SUCCESS,
	REQUEST_PARTS_FAILED,
	GET_SKILL_INFO_PENDING,
	GET_SKILL_INFO_SUCCESS,
	GET_SKILL_INFO_FAILED,
	SORT_PARTS,
	CHANGE_SORT_DIR,
	SET_FILTERS,
	GET_SERIES_PENDING,
	GET_SERIES_SUCCESS,
	GET_SERIES_FAILED,
	GET_SKILLS_PENDING,
	GET_SKILLS_SUCCESS,
	GET_SKILLS_FAILED,
	ADD_PARTS_PENDING,
	ADD_PARTS_SUCCESS,
	ADD_PARTS_FAILED,
	ADD_SKILL_PENDING,
	ADD_SKILL_SUCCESS,
	ADD_SKILL_FAILED,
	GET_WORDTAGS_PENDING,
	GET_WORDTAGS_SUCCESS,
	GET_WORDTAGS_FAILED,
	CHANGE_VIEW,
	STATUS_TEXT,
	ADD_SKILL_STATUS_TEXT,
	REFRESH_SKILL_STATUS_TEXT,
	ADD_PART_STATUS_TEXT,
} from './constants';

export const updateStatus = (text) => ({ type: STATUS_TEXT, payload: text });

export const addSkill = (dispatch, skill) => {

	dispatch( { type: ADD_SKILL_STATUS_TEXT, payload: 'Adding new skill... Please wait.', } );
	dispatch( { type: ADD_SKILL_PENDING, } );
	new Promise((resolve) => {

			resolve(fetch(process.env.REACT_APP_ADD_SKILL_ENDPOINT,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify( skill ),
				}
			))
	}).then(response => response.json())
	.then(data => {
		dispatch( { type:ADD_SKILL_SUCCESS, payload: data.result, } );
		dispatch( { type: ADD_SKILL_STATUS_TEXT, payload: 'New Skill successfully added!', } );
	})
	.catch(error => {
		dispatch( { type:ADD_SKILL_FAILED, payload: error, } );
		dispatch( { type: ADD_SKILL_STATUS_TEXT, payload: `Error adding new Skill: ${error}`, } );
	})
	.finally(() => {

		setTimeout(function() {
			dispatch( { type: ADD_SKILL_STATUS_TEXT, payload: '', } );
		}, 5000);
	});
};

export const addParts = (dispatch, parts) => {

	dispatch( { type: ADD_PART_STATUS_TEXT, payload: 'Adding new part... Please wait.', } );
	dispatch( { type: ADD_PARTS_PENDING, } );
	new Promise((resolve) => {

			resolve(fetch(process.env.REACT_APP_ADD_PARTS_ENDPOINT,
				{
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						"partsToAdd": parts,
					}),
				}
			))
	}).then(response => response.json())
	.then(data => {
		dispatch( { type:ADD_PARTS_SUCCESS, payload: data.result, } );
		dispatch( { type: ADD_PART_STATUS_TEXT, payload: 'New Part successfully added!', } );
	})
	.catch(error => {
		dispatch( { type:ADD_PARTS_FAILED, payload: error, } );
		dispatch( { type: ADD_PART_STATUS_TEXT, payload: `Error adding new Part: ${error}`, } );
	})
	.finally(() => {

		setTimeout(function() {
			dispatch( { type: ADD_PART_STATUS_TEXT, payload: '', } );
		}, 5000);
	});
};

export const getSeries = (dispatch) => {

	dispatch( { type: GET_SERIES_PENDING, } );
	new Promise((resolve) => {

		resolve(fetch(process.env.REACT_APP_SERIES_ENDPOINT,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			}
		))
	})	
	.then(response => response.json())
	.then(data => dispatch( { type:GET_SERIES_SUCCESS, payload: data.series, } ))
	.catch(error => dispatch( { type:GET_SERIES_FAILED, payload: error, } ))
};

export const getSkills = (dispatch) => {

	dispatch( { type: REFRESH_SKILL_STATUS_TEXT, payload: 'Refreshing skills... Please wait.', } );
	dispatch( { type: GET_SKILLS_PENDING, } );
	new Promise((resolve) => {

		resolve(fetch(process.env.REACT_APP_SKILLS_ENDPOINT,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			}
		))
	})
	.then(response => response.json())
	.then(data => {
		dispatch( { type:GET_SKILLS_SUCCESS, payload: data.skills, } );
		dispatch( { type: REFRESH_SKILL_STATUS_TEXT, payload: 'Skills Listing Refreshed!', } );
	})
	.catch(error => {
		dispatch( { type:GET_SKILLS_FAILED, payload: error, } );
		dispatch( { type: REFRESH_SKILL_STATUS_TEXT, payload: `Error: ${error}`, } );
	})
	.finally(() => {

		setTimeout(function() {
			dispatch( { type: REFRESH_SKILL_STATUS_TEXT, payload: '', } );
		}, 2000);
	});
};

export const getWordtags = (dispatch) => {

	dispatch( { type: GET_WORDTAGS_PENDING, } );
	new Promise((resolve) => {

		resolve(fetch(process.env.REACT_APP_WORDTAGS_ENDPOINT,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			}
		))
	})	
	.then(response => response.json())
	.then(data => dispatch( { type:GET_WORDTAGS_SUCCESS, payload: data.wordtags, } ))
	.catch(error => dispatch( { type:GET_WORDTAGS_FAILED, payload: error, } ))
};

export const getParts = (dispatch) => {

	dispatch( { type: REQUEST_PARTS_PENDING, } );
	new Promise((resolve) => {

		resolve(fetch(process.env.REACT_APP_PARTS_ENDPOINT))
	})	
	.then(response => response.json())
	.then(data => {
		dispatch( { type:STATUS_TEXT, payload: `Showing ${data.units.length} part(s).`, } );
		dispatch( { type:REQUEST_PARTS_SUCCESS, payload: data.units, } );
	})
	.catch(error => dispatch( { type:REQUEST_PARTS_FAILED, payload: error, } ))
};

export const searchParts = (dispatch, keyword, stringToSearch, matchType) => {

	let resultIds = [];
	let searchText = keyword.trim();
	if (keyword.length > 0) {

		if ( matchType === 'and' ) {

			searchText = searchText.replace(/\s/g, '|');
		}
		const searchRegex = new RegExp(`{"id":([0-9]+)[^}]*(${searchText})[^}]*`, 'gi');

		let searchResult;
		while ((searchResult = searchRegex.exec(stringToSearch)) !== null) {

			resultIds.push(searchResult[1]);
		}
	}

	dispatch( {
		type: SEARCH_PARTS_SUCCESS,
		payload: {
			resultIds: resultIds,
			searchText: keyword,
			searchMatchType: matchType,
		},
	});

	let statusText = `No part found containing "${keyword}."`;
	if ( resultIds.length > 0 ) {
		statusText = `Showing ${resultIds.length} part(s).`;
	}
	dispatch(updateStatus(statusText));
};

export const getSkillInfo = (dispatch, id) => {

	dispatch( { type: GET_SKILL_INFO_PENDING, payload: id } );
	new Promise((resolve) => {

		resolve(fetch(process.env.REACT_APP_SEARCH_SKILL_ENDPOINT + `/${id}`,
			{
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
			}
		))
	})
	.then(response => response.json())
	.then(data => dispatch( { type:GET_SKILL_INFO_SUCCESS, payload: data.skill, } ))
	.catch( error => dispatch( { type: GET_SKILL_INFO_FAILED, payload: error } ))
};

export const sortParts = (text) => ({ type: SORT_PARTS, payload: text });

export const changeSortDir = (dispatch, sortDir) => {

	dispatch ( { type: CHANGE_SORT_DIR, payload: sortDir } );
};

export const setFilters = (filterObj) => ({ type: SET_FILTERS, payload: filterObj });

export const changeView = (viewType) => ({ type: CHANGE_VIEW, payload: viewType });
